import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  doc,
  deleteDoc,
} from 'firebase/firestore';
import { firestore } from '../config/firebase';

const COLLECTION = 'financedDealTranches';

/**
 * Create a tranche for a financed deal (initial or additional capital).
 * @param {{ dealId: string, amount: number, startDate: string, interestRate?: number | null, type?: string, note?: string }} data
 * @returns {Promise<string>} tranche id
 */
export async function createFinancedDealTranche(data) {
  const { dealId, amount, startDate, interestRate, type, note } = data;
  if (!dealId || !amount || !startDate) {
    throw new Error('dealId, amount and startDate required');
  }
  const docRef = await addDoc(collection(firestore, COLLECTION), {
    dealId,
    amount,
    startDate,
    interestRate: typeof interestRate === 'number' && !Number.isNaN(interestRate) ? interestRate : null,
    type: type || 'initial',
    note: typeof note === 'string' && note.trim() ? note.trim() : null,
  });
  return docRef.id;
}

/**
 * Get all tranches for a deal (for future use in reports/calculations).
 * @param {string} dealId
 * @returns {Promise<Array<object>>}
 */
export async function getFinancedDealTranchesByDeal(dealId) {
  if (!dealId) return [];
  const q = query(
    collection(firestore, COLLECTION),
    where('dealId', '==', dealId)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
}

/**
 * Delete a tranche. Only safe when the tranche's effective date (startDate) has not yet been reached.
 * @param {string} trancheId - document id
 * @returns {Promise<void>}
 */
export async function deleteFinancedDealTranche(trancheId) {
  if (!trancheId) throw new Error('trancheId required');
  await deleteDoc(doc(firestore, COLLECTION, trancheId));
}

